import React from 'react';
import { Link } from 'react-router-dom';
import { Quote, ArrowRight } from 'lucide-react';

export default function TestimonialsPage() {
  return (
    <div>
      {/* Page Header */}
      <section className="hero-gradient pt-32 pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6" data-testid="testimonials-title">
            Client Success Stories
          </h1>
          <p className="text-lg sm:text-xl text-white/75 max-w-2xl mx-auto leading-relaxed">
            See how fractional leadership has transformed startups like yours.
          </p>
        </div>
      </section>

      {/* Placeholder */}
      <section className="py-20 lg:py-28 bg-background px-4 sm:px-6 lg:px-8" data-testid="testimonials-grid">
        <div className="max-w-3xl mx-auto text-center">
          <Quote className="w-16 h-16 text-primary/15 mx-auto mb-8" />
          <h2 className="text-2xl font-bold text-foreground mb-4">Coming Soon</h2>
          <p className="text-muted-foreground leading-relaxed max-w-lg mx-auto">
            We're gathering success stories from our clients. Check back soon to read about the impact of fractional leadership on real companies.
          </p>
        </div>
      </section>

      {/* CTA */}
      <section className="relative py-24 lg:py-32 px-4 sm:px-6 lg:px-8 overflow-hidden">
        <div className="absolute inset-0 cta-gradient animate-gradient" />
        <div className="relative z-10 max-w-3xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-8">
            Be our next success story
          </h2>
          <Link
            to="/contact"
            data-testid="testimonials-cta-btn"
            className="inline-flex items-center justify-center gap-2 rounded-lg bg-accent text-white font-semibold text-lg px-10 py-4 hover:bg-accent/90 hover-lift group"
          >
            Start Your Journey
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
      </section>
    </div>
  );
}
